module.exports = __webpack_public_path__ + "static/elderly-swinging-square.12caa1e5.jpg";